(function (window, document, $) {
    'use strict';

    if ( $('.modal-schedule').length ) {
        var tableContent, date, d, m, y, displayDate, start, end, displayStart, displayEnd, time, location, online;
        var days = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];
        var $modal = $('.modal-schedule').last();

        $('.show-schedule').on('click', function(e) {
            var data = JSON.parse($(this).data('schedule'));
            var $tableBody = $modal.find('tbody');
            var rowTemplate = $('.schedule-row').first().html();
            tableContent = '';
            e.preventDefault();

            // create table body content from template row
            for (var i = 0; i < data.length; i++) {
              date = data[i].date || false;
              start = data[i].start || false;
              end = data[i].end || false;
              location = data[i].location || 'Volgt nog';
              online = data[i].online;

              if ( date ) {
                date = new Date(date);
                d = pad(date.getUTCDate());
                m = pad(date.getUTCMonth() + 1); // yay zero-indexing!
                y = date.getUTCFullYear();
                displayDate = days[date.getDay()] + ' ' + d + '-' + m + '-' + y;
              } else {
                displayDate = 'onbekend';
              }

              if ( start ) {
                displayStart = start.substr(0,5);
              }

              if ( end ) {
                displayEnd = end.substr(0,5);
              }

              if ( start && end ) {
                time = displayStart + ' - ' + displayEnd;
              } else {
                time = 'onbekend';
              }

              var thisRowContent = rowTemplate
                .replace('[[ index ]]', (i + 1) )
                .replace('[[ date ]]', displayDate)
                .replace('[[ time ]]', time)
                .replace('[[ location ]]', location);

              var thisRowElement = document.createElement('table');
              thisRowElement.innerHTML = thisRowContent;

              if (online) {
                var thisRowAddresCell = thisRowElement.querySelector('[data-js-bind="schedule-address-cell"]');
                thisRowAddresCell.parentElement.removeChild(thisRowAddresCell);
                $modal.find('[data-js-bind="schedule-address-header"]').remove();
              }

              tableContent += thisRowElement.children[0].innerHTML;

            }

            // add rows to table
            $tableBody.html(tableContent);

            // show modal
            $modal.addClass('show-modal');
        });
    }

    function pad(input) {
        var input = input.toString() || false;

        if ( input === false ) {
            return false;
        } else {
            return ('00'+input).substring(input.length);
        }
    }
}(this, document, jQuery));
